const state = {
  currentTable: null,
  currentTablePage: null,
  currentTablePerPage: null,
  currentTableSearch: null,
  currentTableStateFilter: null,
};

const getters = {};

const actions = {
  setCurrentTable(context, table) {
    context.commit('SET_CURRENT_TABLE', table);
  },

  setCurrentTablePage(context, { value, table }) {
    context.dispatch('setValue', { mutation: 'SET_CURRENT_TABLE_PAGE', table, value });
  },

  setCurrentTablePerPage(context, { value, table }) {
    context.dispatch('setValue', { mutation: 'SET_CURRENT_TABLE_PER_PAGE', table, value });
  },

  setCurrentTableSearch(context, { value, table }) {
    context.dispatch('setValue', { mutation: 'SET_CURRENT_TABLE_SEARCH', table, value });
  },

  setCurrentTableStateFilter(context, { value, table }) {
    context.dispatch('setValue', { mutation: 'SET_CURRENT_TABLE_STATE_FILTER', table, value });
  },

  cleanCurrentTableSearch(context) {
    context.commit('SET_CURRENT_TABLE_SEARCH', null);
  },

  setValue(context, { mutation, table, value }) {
    if (context.state.currentTable === table) {
      context.commit(mutation, value);
    }
  },
};

const mutations = {
  SET_CURRENT_TABLE(_, value) {
    state.currentTable = value;
  },

  SET_CURRENT_TABLE_PAGE(_, value) {
    state.currentTablePage = value;
  },

  SET_CURRENT_TABLE_PER_PAGE(_, value) {
    state.currentTablePerPage = value;
  },

  SET_CURRENT_TABLE_SEARCH(_, value) {
    state.currentTableSearch = value;
  },

  SET_CURRENT_TABLE_STATE_FILTER(_, value) {
    state.currentTableStateFilter = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
